module.exports = __webpack_public_path__ + "img/2021 Twitter logo - blue.7571ea13.png";